export default {
    data() {
        return {
            tituloOverlay: '',
            carregando: false,
        }
    },
    methods: {
        setMesagemCarregando(msg) {
            this.carregando = true
            this.tituloOverlay = msg
          },
          resetCarregando() {
            this.carregando = false
            this.tituloOverlay = ''
          }        
    }
}